import { map, reject, find } from "lodash/collection"
import messages from "../messages/lists"

const getResourceTypes = () => {
  return typeof window !== 'undefined' && window.contentTypes
    ?  Object.keys(window.contentTypes).filter(key => key !== 'cms_page').map(key => ({
      name: key,
      label: window.contentTypes[key],
    }))
    : [
      { name: "image", label: "Image" },
      { name: "audio", label: "Audio" },
      { name: "video", label: "Video" },
      { name: "photo_album", label: "Photo Album" },
      { name: "book", label: "Book" },
      { name: "postcard", label: "Postcard" },
      { name: "diary", label: "Diary" },
      { name: "bound_volume", label: "Bound Volume" },
      { name: "article", label: "Article" },
      { name: "correspondence", label: "Correspondence" },
      { name: "multi_page", label: "Multi-Page Document" },
      { name: "map", label: "Map" },
      { name: "object", label: "Physical Object" },
      { name: "page", label: "Page" },
      { name: "object_image", label: "Object Image" },
      { name: "collection", label: "Collection" },
      { name: "unspecified", label: "Unspecified" },
      { name: "onboarding_step", label: "Onboarding Step" },
      { name: "index_card", label: "Index Card" },
      { name: "finding_aid", label: "Finding aid" },
      { name: "archive_item", label: "Archive item" },
    ]
}
// Shouldn't be able to filter on these ones on the search page
const filterExclude = ["page", "object_image"]

export const filterableResourceTypes = () => reject(
  getResourceTypes(),
  type => filterExclude.indexOf(type.name) >= 0
)

export const filterableResourceTypeNames = () => map(filterableResourceTypes(), "name")

export function getResourceLabel(name, formatMessage) {
  if (formatMessage && name in messages) {
    return formatMessage(messages[name])
  }
  const type = find(getResourceTypes(), { name })
  return type ? type.label : name
}



// WEBPACK FOOTER //
// ./webapp/scripts/resourceTypes.js